import moment from 'moment';
import { DataTable } from 'simple-datatables';
import Swal from 'sweetalert2';
import authHelper from './helpers/authHelper';
import { axiosErrorHandler, axiosResponseHandler, callTheApServerGet, callTheApServerPost } from './helpers/axiosHelper';
import { hydrateApBasicData } from './helpers/basicHelper';
import { addDNoneClass, byId } from './helpers/utility';






authHelper.validate();
hydrateApBasicData();


const updateRedeemRequestCardDivElement = byId('updateRedeemRequestCardDivElement');
const redeemIdInput = byId('redeemIdInput');
const userIdInput = byId('userIdInput');
const methodNameInput = byId('methodNameInput');
const methodIdInput = byId('methodIdInput');
const amountInput = byId('amountInput');
const updateRedeemRequestCancelBtn = byId('updateRedeemRequestCancelBtn');



const redeemRequestUpdateInitFun = ({ sn, userId, amount, methodName, methodId }) => {

    addDNoneClass(updateRedeemRequestCardDivElement, false);

    // console.log(userIdInput);
    redeemIdInput.value = sn;
    userIdInput.value = userId;
    methodNameInput.value = methodName;
    methodIdInput.value = methodId;
    amountInput.value = amount;

};

window.redeemRequestUpdateInitFun=redeemRequestUpdateInitFun;

const redeemRequestUpdateCancelFun = async () => {
    addDNoneClass(updateRedeemRequestCardDivElement, true);
};

updateRedeemRequestCancelBtn.addEventListener('click', redeemRequestUpdateCancelFun);

const updateRedeemRequestActionSelectInput = byId('updateRedeemRequestActionSelectInput');
const updateRedeemRequestCommentInput = byId('updateRedeemRequestCommentInput');

const redeemRequestUpdateFun = async () => {
   


 

    try {
        const data = {
            sn: redeemIdInput.value,
            action: updateRedeemRequestActionSelectInput.value,
            comment: updateRedeemRequestCommentInput.value
        };
        const response = await callTheApServerPost('/users/updateRedeemRequest', { data: data });
        axiosResponseHandler(response);
        const res = response.data;
        console.log(res);

        if (res.status === 'success') {
            Swal.fire({
                title: 'Request Updated Successfully',
                icon: 'success',
                showConfirmButton: false,


                allowOutsideClick: false,


            });

            setTimeout(() => {
                location.reload();
            }, 3000);
        }
    } catch (error) {
        axiosErrorHandler(error);
        console.log(error);
    }
};

const updateRedeemRequestSubmitBtn = byId('updateRedeemRequestSubmitBtn');

updateRedeemRequestSubmitBtn.addEventListener('click', redeemRequestUpdateFun);

const fetchRedeemRequestData = async () => {


   

    try {

        const response = await callTheApServerGet(`/users/allRedeemRequests`);
        
        axiosResponseHandler(response);
        const res = response.data;




        const data_table_body = byId('data_table_body');

        if (res.status === 'success') {

            console.log(res.redeemRequestsData[0]);
            // adding data to table
            let i = 0;
            while (res.redeemRequestsData.length > i) {



                const { sn, userId, methodName, methodId, amount, status,comment, createdAt, updatedAt } = res.redeemRequestsData[i];
                const date = moment(createdAt * 1000).format('DD/MM/YYYY');
                const time = moment(createdAt * 1000).format('LT');
                const date2 = moment(updatedAt * 1000).format('DD/MM/YYYY');
                const time2 = moment(updatedAt * 1000).format('LT');

                
              const   updateBtnClass=  (status !=='PENDING')? 'd-none':'';

                data_table_body.innerHTML += `   
                                    <tr>
                                        <th scope="row">${sn}</th>
                                        <td>${userId}</td>
                                     
                                      
                                    
                                        <td>${methodName}</td>
                                        <td>${methodId}</td>
                                        <td>₹${amount}</td>
                                        <td>${status}</td>
                                        <td>${comment}</td>
                                 
                                        <td>${date} <br> ${time}</td>
                                        <td>${date2} <br> ${time2}</td>
                                       
                                        <td> <button  class="btn btn-success ${updateBtnClass}" onclick="redeemRequestUpdateInitFun(${JSON.stringify({ sn, userId, amount, methodName, methodId }).split('"').join('&quot;')})">Update</button> </td>
                                    
                                    
                                    </tr>
                                    `;
                i++;
            }

            // Initiate Datatables



            const simpleDatatables = new DataTable('#data_table', {
                // searchable: false,
                // perPageSelect: false,


            });
            simpleDatatables;

        }

    

    
    } catch (error) {
        axiosErrorHandler(error);
        console.log(error);
    }
};

fetchRedeemRequestData();




